import { render, staticRenderFns } from "./DigitalApplicationState.vue?vue&type=template&id=19c8cb30&scoped=true&"
import script from "./DigitalApplicationState.vue?vue&type=script&lang=js&"
export * from "./DigitalApplicationState.vue?vue&type=script&lang=js&"
import style0 from "./DigitalApplicationState.vue?vue&type=style&index=0&id=19c8cb30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c8cb30",
  null
  
)

export default component.exports